










































































import Vue from 'vue';
import Component from 'vue-class-component';

@Component({
  name: 'about-us',
  components: {},
})
export default class AboutUsPage extends Vue {
}
